import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TransitionContainer from '../../components/Transition/TranstionContainer';

import VoteRegistrationStep4Form from '../../components/VoteRegistration/VoteRegistrationStep4Form';

import { onGoToStep, saveForm } from './actions';
import { cacheFormData } from '../../utils/formCaching/actions';

import {
    ContainerStyled,
    LegalInfoWrapper,
    FormWrapper
} from '../DefaultStyles/AssessmentDetails';

import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import LegalInfo from '../../components/Widget/LegalInfo';

const VoteRegistrationStep4 = props => (
    <TransitionContainer
        isSubmitting={props.isSubmitting}
        isBackTransition={props.isBackTransition}
        zIndex={26}
    >
        <ContainerStyled>
            <VoteRegistrationSidebar loadRep={true} title={'Voter Registration'} />
            <FormWrapper>
                <VoteRegistrationStep4Form
                    isOnlineRegistrationAvailable={props.isOnlineRegistrationAvailable}
                    onBack={() => {
                        props.onGoToStep(3, 'back');
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.saveForm(values, [5, 6, 7]);
                    }}
                    infoTextIdNumber={props.infoTextIdNumber}
                    maxLengthIdNumber={props.maxLengthIdNumber}
                    minLengthIdNumber={props.minLengthIdNumber}
                />
                {props.isMobileResolution && (
                    <LegalInfoWrapper>
                        <LegalInfo />
                    </LegalInfoWrapper>
                )}
            </FormWrapper>
        </ContainerStyled>
    </TransitionContainer>
);

VoteRegistrationStep4.propTypes = {
    onGoToStep: PropTypes.func.isRequired,
    saveForm: PropTypes.func.isRequired,
    infoTextIdNumber: PropTypes.string,
    maxLengthIdNumber: PropTypes.number,
    minLengthIdNumber: PropTypes.number,
    isOnlineRegistrationAvailable: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    isBackTransition: PropTypes.bool,
    isMobileResolution: PropTypes.bool,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => ({
        infoTextIdNumber: state.voteRegistration.completeVoteRegistration.idNumberMsg,
        maxLengthIdNumber: state.voteRegistration.completeVoteRegistration.idLengthMax,
        minLengthIdNumber: state.voteRegistration.completeVoteRegistration.idLengthMin,
        isOnlineRegistrationAvailable:
            state.voteRegistration.completeVoteRegistration.isOnlineRegistrationAvailable,
        isSubmitting: state.voteRegistration.isSubmitting,
        isBackTransition: state.voteRegistration.isBackTransition,
        isMobileResolution: state.widget.isMobileResolution
    }),
    { onGoToStep, saveForm, cacheFormData }
)(VoteRegistrationStep4);



// WEBPACK FOOTER //
// ./src/containers/VoteRegistration/VoteRegistrationStep4.jsx